import store from '../../../store';
import Events from '../../../util/EventEmitter';
import { loadCharacterData } from '../CombatLoader';
import { CombatPlayerScene } from './CombatPlayerScene';
import { PreloadScene } from './PreloadScene';

export default class DefaultScene extends Phaser.Scene {
  eventId = '';
  private playbackRequest=0;

  init() {
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.playbackRequest++;
      Events.off(this.eventId);
    });
  }

  create() {
    if (store.getState().fight.fight) {
      this.start({ ...store.getState().fight.fight, onFinish: this.game.registry.get('fightOnFinish') });
    }

    this.eventId = Events.on('setFightData', async (data) => {
      this.start(data);
    });

    this.events.addListener(Phaser.Scenes.Events.DESTROY, () => {
      Events.off(this.eventId);
    });
  }

  async start(data: any) {
    const request=++this.playbackRequest;
    try {
      const timer = Date.now();
      const res = await loadCharacterData(this, data);
      if(request!==this.playbackRequest||!this.sys.isActive())return;

      this.safelyRemoveScene('combatPlayer');
      this.safelyRemoveScene('preload');
      this.scene.add('combatPlayer', CombatPlayerScene, false);
      this.scene.add('preload', PreloadScene, true, { ...res, startTime: timer });
    } catch (error) {
      if(request!==this.playbackRequest||!this.sys.isActive())return;
      console.error('Combat playback failed', error);
      Events.emit('combatPlaybackFailed');
    }
  }

  safelyRemoveScene(key: string) {
    if (key in this.game.scene.keys) {
      this.scene.remove(key);
    }
  }
}
